import { Box, Typography } from '@mui/material'
import React from 'react'
import CustomePieChart from '../../dashboard/chart/CustomePieChart'


const assetAllocation = {
  "data": [
    [
      "AIF",
      287004566.64
    ],
    [
      "Debt",
      84178380
    ],
    [
      "Equity",
      847635290.36
    ],
    [
      "Mutual Funds",
      2480082832.989689
    ],
    [
      "PMS",
      545788812.1800001
    ]
  ],
  "labelData": [
    {
      "label": "AIF",
      "value": 6.7614967078183
    },
    {
      "label": "Debt",
      "value": 1.9831455851133206
    },
    {
      "label": "Equity",
      "value": 19.96931021794054
    },
    {
      "label": "Mutual Funds",
      "value": 58.42789230392458
    },
    {
      "label": "PMS",
      "value": 12.85815518520326
    }
  ],
  "totalValue": {
    "label": "Market Value",
    "value": 4244689882.169689
  }
}


const ApplicationChart = () => {
  return (
    <Box sx={{ padding: '25px 30px 10px 30px' }}>
      <Typography variant='h2' >Number of Applications</Typography>
      <CustomePieChart {...{ ...assetAllocation, isLoading: false, showSlider: true, title: 'Number of Applications' }} />

    </Box>
  )
}

export default ApplicationChart